import React from "react";
import { shallowEqual } from "react-redux";
import type { FormattedUscCashPriceType } from "../../../../../shared-logic/utils/uscPriceUtils";
import { getTotalPriceSelector } from "../../../../utils/priceUtils";
import { useUscSelector } from "../../../../redux/store";
import { useUscLabel } from "../../../../utils/labels";

type PropsType = {
    formattedCashPrice: FormattedUscCashPriceType;
    showSecondaryPrice: boolean;
};

const UscCashComponent = ({ formattedCashPrice, showSecondaryPrice }: PropsType): JSX.Element => {
    const { cashLoading } = useUscSelector(getTotalPriceSelector(), shallowEqual);
    const cashLoadingLabel = useUscLabel("uscLoading");

    const { primaryPrice, secondaryPrice } = formattedCashPrice.isPromotion
        ? formattedCashPrice.formattedDiscount
        : formattedCashPrice.formattedCash;

    return cashLoading ? (
        <span>{cashLoadingLabel}</span>
    ) : (
        <>
            <span dangerouslySetInnerHTML={{ __html: primaryPrice }} />
            {secondaryPrice && showSecondaryPrice && <span dangerouslySetInnerHTML={{ __html: secondaryPrice }} />}
        </>
    );
};

export default UscCashComponent;
